import "./Blogs.css";

export const Blogs = (props) => {
  return (
    <div>
      <div className="header_blogs">
        <h2>BLOGS</h2>
        <p>coming soon</p>
      </div>
    </div>
  );
};
